import { useCallback } from 'react'
import { useStore } from 'react-redux'
import { NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL } from '#/consts/neighborhood_level'
import { hash2MapUrl, state2Hash } from '#/utils/url'

export const breadcrumbsZones = (zones: TopHap.Property['zones'] = []) => {
  const zoneTypes: TopHap.ZoneType[] = ['state', 'county', 'city', 'zip']
  const bZones = zoneTypes.map(type => zones.find(e => e.type === type)).filter(e => e) as TopHap.Property['zones']
  const neighborhood = zones.find(e => e.type === 'neighborhood' && e.level <= NEIGHBORHOOD_RESIDENTIAL_SUBDIVISION_LEVEL)
  if (neighborhood) return [...bZones, neighborhood]
  else return bZones
}

export const useBreadcrumbs = (zones: TopHap.Property['zones'] = []) => {
  const store = useStore<TopHap.StoreState>()

  const zoneLink = useCallback((id: string, keepSider = false) => {
    const state = store.getState()
    const hash = state2Hash(state)
    hash.l = [id]
    if (keepSider) {
      hash.sp = {
        ...state.ui.sider.properties,
        keep: true
      }
    }

    return hash2MapUrl(hash)
  }, [store])

  return {
    zones: breadcrumbsZones(zones),
    zoneLink
  }
}
